import React,{useState, createContext } from 'react';
import Sidebar from './components/Sidebar/Sidebar';
import About from "./components/About/About";
import TechStack from './components/TechStack/TechStack';
import Project from './components/Project/Project';
import ProjectList from './components/Project/ProjectList';
import WorkExperience from "./components/Workexperience/WorkExperience";
import Education from './components/Education/Education';
import Testimonial from './components/Testimonial/Testimonal';
import Contact from './components/Contact/Contact';
import ScrollToTop from "react-scroll-to-top";
import NavbarMobileView from "./components/Sidebar/NavbarMobileView"
import "./App.css";

const App = () => {
  return (
    <>

      <NavbarMobileView/>
      <Sidebar />
      <About />
      <WorkExperience />
      <TechStack />
      <Education />
      <Project />
      <Testimonial />
      <Contact />

      <ScrollToTop smooth={true}
        top="20"
        color="white"
        height='20'
        width='20'
        style={{ borderRadius: "90px", backgroundColor: "#38004c" }}
      />
    </>
  );
};
export default App;